import { Box, Text, Card, Flex, Grid, Badge } from '@radix-ui/themes';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import {reportService} from '../../services/guardian/reportService';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import UserAvatar from '../common/UserAvatar';
import CircleProgress from '../shared/CircleProgress';
import CourseReport from '../shared/report/CourseReport';
// import QuizReport from '../shared/report/QuizReport';
import StudentQuizReport from '../shared/report/StudentQuizReport';
const GuardianStudent = () => {
    const { studentId } = useParams();
    const student = useSelector(state => state.guardian.students.find(student => student.id === parseInt(studentId)));
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [report, setReport] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedQuiz, setSelectedQuiz] = useState(null);
    useEffect(() => {
        getStudentReport();
    }, [studentId]);

    const getStudentReport = async () => {
        try {
            setLoading(true);
            const response = await reportService.getStudentReport(studentId);
            setReport(response.student_report);
            if (response.student_report?.length > 0) {
                setSelectedCourse(response.student_report[0]);
            }
        } catch (error) {
            console.error('Error fetching student report:', error);
            toast.error('Error fetching student report');
            setError(error);
        } finally {
            setLoading(false);
        }
    }

    const calculateCourseStats = (course) => {
        const allAttempts = course.teaching_plans.flatMap(plan => 
            plan.quizzes.flatMap(quiz => quiz.quiz_attempts)
        );

        const averagePercentage = allAttempts.length > 0
            ? allAttempts.reduce((sum, attempt) => sum + attempt.percentage, 0) / allAttempts.length
            : 0;

        return { averagePercentage, totalAttempts: allAttempts.length };
    };

    const handleCourseSelected = (course) => {
        setSelectedCourse(course);
        setSelectedQuiz(null);
    }

    const handleQuizSelected = (quiz) => {
        setSelectedQuiz(quiz);
    }

    return (
        <Box width="100%" maxWidth="1080px" p="4">
            {/* Student Header */}
            <Card mb="4">
                <Flex direction="row" gap="2">
                    <UserAvatar user={student.user} size="8" />
                    <Flex direction="column">
                        <Text size="6" weight="bold">{student.user.firstname} {student.user.lastname}</Text>
                        <Text size="4" color="gray">{student.school?.name}</Text>
                        <Text size="4" color="gray">{student.current_level?.label}</Text>
                    </Flex>
                    <Flex>
                        <CircleProgress
                            progress={report ? report.reduce((sum, course) => {
                                const stats = calculateCourseStats(course);
                                return sum + stats.averagePercentage;
                            }, 0) / (report.length || 1) : 0}
                            size={40}
                            label={`${Math.floor(report ? report.reduce((sum, course) => {
                                const stats = calculateCourseStats(course);
                                return sum + stats.averagePercentage;
                            }, 0) / (report.length || 1) : 0)}%`}
                            labelSize="1"
                        />
                    </Flex>
                </Flex>
            </Card>

            {/* Main Content */}
            <Grid columns="12" gap="4">
                {/* Course List */}
                <Box gridColumn="span 4">
                    <Card>
                        <Text weight="bold" size="3" mb="3">Courses</Text>
                        <Flex direction="column" gap="2">
                            {report && report.map(course => {
                                const stats = calculateCourseStats(course);
                                return (
                                    <Box 
                                        key={course.id}
                                        onClick={() => handleCourseSelected(course)}
                                        style={{ 
                                            cursor: 'pointer',
                                            backgroundColor: selectedCourse?.id === course.id ? 'var(--gray-3)' : 'transparent',
                                            padding: '12px',
                                            borderRadius: '4px'
                                        }}
                                    >
                                        <Flex justify="between" align="center">
                                            <Flex direction="column" gap="1">
                                                <Text weight="bold" size="2">{course.subject.name}</Text>
                                                <Text size="1" color="gray">{course.level.name}</Text>
                                            </Flex>
                                            <CircleProgress
                                                progress={stats.averagePercentage}
                                                size={40}
                                                label={`${Math.floor(stats.averagePercentage)}%`}
                                                labelSize="1"
                                            />
                                        </Flex>
                                    </Box>
                                );
                            })}
                        </Flex>
                    </Card>
                </Box>

                {/* Quiz Details */}
                <Box gridColumn="span 8">
                    <Card>
                        {selectedCourse ? (
                            selectedQuiz ? (
                                <StudentQuizReport studentId={studentId} quizId={selectedQuiz.id} />
                            ) : (
                                <CourseReport course_report={selectedCourse} onQuizSelected={setSelectedQuiz} />
                            )
                        ) : (
                            <Text color="gray">Select a course to view details</Text>
                        )}
                    </Card>
                </Box>
            </Grid>
        </Box>
    );
};

export default GuardianStudent;
